export interface LogoSampleEntry {
  id: string;
  name: string;
  square_image: string;
}

// A hand-picked sample of real Integration logos for the side rails -- purely decorative, no live
// fetch. Fine that it's static and never grows to reflect every Integration Merge ships; nobody
// is meant to read it as a catalogue.
export const LOGO_SEED: LogoSampleEntry[] = [
  {
    id: "seed-confluence",
    name: "Confluence",
    square_image: "https://merge-api-public.s3.amazonaws.com/media/Confluence_Square.png",
  },
  {
    id: "seed-sharepoint",
    name: "SharePoint",
    square_image: "https://merge-api-public.s3.amazonaws.com/media/PlatformSharepoint_square.png",
  },
  {
    id: "seed-workday",
    name: "Workday",
    square_image: "https://merge-api-public.s3.amazonaws.com/media/PlatformWorkday.png",
  },
  {
    id: "seed-netsuite",
    name: "NetSuite",
    square_image: "https://merge-api-public.s3.amazonaws.com/media/Netsuite_square.png",
  },
  {
    id: "seed-quickbooks-online",
    name: "QuickBooks Online",
    square_image: "https://merge-api-public.s3.amazonaws.com/media/QuickBooks-square_Uf26B71.png",
  },
  {
    id: "seed-microsoft-outlook-email",
    name: "Microsoft Outlook Email",
    square_image: "https://merge-api-public.s3.amazonaws.com/media/Outlook_email_square.png",
  },
  {
    id: "seed-notion",
    name: "Notion",
    square_image: "https://merge-api-public.s3.amazonaws.com/media/notion_square.png",
  },
  {
    id: "seed-salesforce",
    name: "Salesforce",
    square_image: "https://merge-api-public.s3.amazonaws.com/media/PlatformSalesforce.png",
  },
  {
    id: "seed-jira",
    name: "Jira",
    square_image: "https://merge-api-public.s3.amazonaws.com/media/Jira_Square.png",
  },
  {
    id: "seed-jira-data-center",
    name: "Jira Data Center",
    square_image: "https://merge-api-public.s3.amazonaws.com/media/PlatformJira.png",
  },
  {
    id: "seed-trello",
    name: "Trello",
    square_image: "https://merge-api-public.s3.amazonaws.com/media/Trello_Square_Logo_WsxDwGx.png",
  },
  {
    id: "seed-adp-workforce-now",
    name: "ADP Workforce Now",
    square_image: "https://merge-api-public.s3.amazonaws.com/media/ADP_Workforce_Now_Square.png",
  },
  {
    id: "seed-asana",
    name: "Asana",
    square_image: "https://merge-api-public.s3.amazonaws.com/media/asana-square-logo2.jpeg",
  },
  {
    id: "seed-bamboohr",
    name: "BambooHR",
    square_image: "https://merge-api-public.s3.amazonaws.com/media/BambooHR_Square_Logo.jpg",
  },
  {
    id: "seed-box",
    name: "Box",
    square_image: "https://merge-api-public.s3.amazonaws.com/media/PlatformBox_square_jNrwZ7n.png",
  },
  {
    id: "seed-dayforce",
    name: "Dayforce",
    square_image: "https://merge-api-public.s3.amazonaws.com/media/PlatformDayforce.png",
  },
  {
    id: "seed-dropbox",
    name: "Dropbox",
    square_image:
      "https://merge-api-public.s3.amazonaws.com/media/PlatformDropbox_square_mLnVhny.png",
  },
  {
    id: "seed-factorial",
    name: "Factorial",
    square_image: "https://merge-api-public.s3.amazonaws.com/media/Factorial_Square_Logo.png",
  },
  {
    id: "seed-freshdesk",
    name: "Freshdesk",
    square_image: "https://merge-api-public.s3.amazonaws.com/media/Freshdesk_Square_Logo.jpeg",
  },
  {
    id: "seed-freshsales",
    name: "Freshsales",
    square_image: "https://merge-api-public.s3.amazonaws.com/media/PlatformFreshsales.jpg",
  },
  {
    id: "seed-freshservice",
    name: "Freshservice",
    square_image: "https://merge-api-public.s3.amazonaws.com/media/Platformfreshservice_square.png",
  },
  {
    id: "seed-gem",
    name: "Gem",
    square_image: "https://merge-api-public.s3.amazonaws.com/media/PlatformGem_xvVcK15.png",
  },
  {
    id: "seed-github-issues",
    name: "GitHub Issues",
    square_image: "https://merge-api-public.s3.amazonaws.com/media/Github_Issues_Square_Logo.png",
  },
  {
    id: "seed-greenhouse",
    name: "Greenhouse",
    square_image: "https://merge-api-public.s3.amazonaws.com/media/Greenhouse_Square_Logo.jpg",
  },
  {
    id: "seed-google-drive",
    name: "Google Drive",
    square_image: "https://merge-api-public.s3.amazonaws.com/media/Google_Drive_Square.png",
  },
  {
    id: "seed-hibob",
    name: "Hibob",
    square_image: "https://merge-api-public.s3.amazonaws.com/media/PlatformHibob.png",
  },
  {
    id: "seed-hive",
    name: "Hive",
    square_image: "https://merge-api-public.s3.amazonaws.com/media/Hive_Square_Logo.png",
  },
  {
    id: "seed-hubspot",
    name: "HubSpot",
    square_image: "https://merge-api-public.s3.amazonaws.com/media/Hubspot_square.jpg",
  },
  {
    id: "seed-ironclad",
    name: "Ironclad",
    square_image: "https://merge-api-public.s3.amazonaws.com/media/IronClad_Square.png",
  },
  {
    id: "seed-jira-service-management",
    name: "Jira Service Management",
    square_image: "https://merge-api-public.s3.amazonaws.com/media/Jira_Service_Management.jpg",
  },
  {
    id: "seed-justworks",
    name: "Justworks",
    square_image: "https://merge-api-public.s3.amazonaws.com/media/Justworks_Square_Logo.jpg",
  },
  {
    id: "seed-lattice-hris",
    name: "Lattice HRIS",
    square_image: "https://merge-api-public.s3.amazonaws.com/media/lattice_square_hGJZ3kH.png",
  },
  {
    id: "seed-lever",
    name: "Lever",
    square_image: "https://merge-api-public.s3.amazonaws.com/media/Lever_Square_Logo_oYg8yBW.jpg",
  },
  {
    id: "seed-linear",
    name: "Linear",
    square_image: "https://merge-api-public.s3.amazonaws.com/media/linear_square.png",
  },
  {
    id: "seed-microsoft-entra-id",
    name: "Microsoft Entra ID",
    square_image: "https://merge-api-public.s3.amazonaws.com/media/Entra_ID_square_9CzLgQT.png",
  },
  {
    id: "seed-microsoft-teams",
    name: "Microsoft Teams",
    square_image: "https://merge-api-public.s3.amazonaws.com/media/Microsoft_Teams_Square.png",
  },
  {
    id: "seed-okta",
    name: "Okta",
    square_image: "https://merge-api-public.s3.amazonaws.com/media/Okta_Square.png",
  },
  {
    id: "seed-oracle-cloud-human-capital-management-hcm",
    name: "Oracle Cloud Human Capital Management (HCM)",
    square_image: "https://merge-api-public.s3.amazonaws.com/media/Oracle_square.png",
  },
  {
    id: "seed-paycor",
    name: "Paycor",
    square_image: "https://merge-api-public.s3.amazonaws.com/media/Platformpaycor_square.png",
  },
  {
    id: "seed-personio",
    name: "Personio",
    square_image: "https://merge-api-public.s3.amazonaws.com/media/Personio_Square_FoVaG7T.png",
  },
  {
    id: "seed-rippling",
    name: "Rippling",
    square_image: "https://merge-api-public.s3.amazonaws.com/media/Platformrippling_rR8x3bN.png",
  },
  {
    id: "seed-sap-successfactors",
    name: "SAP SuccessFactors",
    square_image:
      "https://merge-api-public.s3.amazonaws.com/media/SuccessFactors_Square_Logo_BcXogF0.jpg",
  },
  {
    id: "seed-wrike",
    name: "Wrike",
    square_image: "https://merge-api-public.s3.amazonaws.com/media/Wrike_Square_Logo.png",
  },
  {
    id: "seed-freshteam",
    name: "Freshteam",
    square_image: "https://merge-api-public.s3.amazonaws.com/media/Freshteam_Square.png",
  },
  {
    id: "seed-gusto",
    name: "Gusto",
    square_image: "https://merge-api-public.s3.amazonaws.com/media/PlatformGusto_square_image.png",
  },
  {
    id: "seed-zoho-desk",
    name: "Zoho Desk",
    square_image: "https://merge-api-public.s3.amazonaws.com/media/Zoho_Desk_Square_Logo.png",
  },
  {
    id: "seed-kallidus",
    name: "Kallidus",
    square_image: "https://merge-api-public.s3.amazonaws.com/media/Kallidus_square.png",
  },
  {
    id: "seed-jobsoid",
    name: "Jobsoid",
    square_image: "https://merge-api-public.s3.amazonaws.com/media/Jobsoid_Square_Logo_L2UcdnQ.jpg",
  },
  {
    id: "seed-hr-partner",
    name: "HR Partner",
    square_image: "https://merge-api-public.s3.amazonaws.com/media/HRPartner_Square_Logo.jpg",
  },
  {
    id: "seed-jazzhr",
    name: "JazzHR",
    square_image: "https://merge-api-public.s3.amazonaws.com/media/JazzHR_Square_Logo_WQcMDMd.jpg",
  },
  {
    id: "seed-zoho-bugtracker",
    name: "Zoho BugTracker",
    square_image: "https://merge-api-public.s3.amazonaws.com/media/ZohoBugTracker_square.png",
  },
  {
    id: "seed-smartrecruiters",
    name: "SmartRecruiters",
    square_image:
      "https://merge-api-public.s3.amazonaws.com/media/SmartRecruiters_Square_Logo_j8vLfEW.png",
  },
  {
    id: "seed-front",
    name: "Front",
    square_image: "https://merge-api-public.s3.amazonaws.com/media/PlatformFront_square.png",
  },
  {
    id: "seed-close",
    name: "Close",
    square_image: "https://merge-api-public.s3.amazonaws.com/media/PlatformClose.jpg",
  },
  {
    id: "seed-namely",
    name: "Namely",
    square_image: "https://merge-api-public.s3.amazonaws.com/media/Namely_Square_Logo.jpg",
  },
  {
    id: "seed-teamtailor",
    name: "Teamtailor",
    square_image: "https://merge-api-public.s3.amazonaws.com/media/Teamtailor_Square_Logo.jpg",
  },
  {
    id: "seed-zoho-books",
    name: "Zoho Books",
    square_image: "https://merge-api-public.s3.amazonaws.com/media/ZohoBooks_Square_Logo.png",
  },
  {
    id: "seed-ukg-ready",
    name: "UKG Ready",
    square_image: "https://merge-api-public.s3.amazonaws.com/media/UKG_square_geaH8qP.png",
  },
  {
    id: "seed-trinet",
    name: "TriNet",
    square_image: "https://merge-api-public.s3.amazonaws.com/media/Trinet.png",
  },
  {
    id: "seed-officient",
    name: "Officient",
    square_image: "https://merge-api-public.s3.amazonaws.com/media/Officient_square.png",
  },
  {
    id: "seed-intercom",
    name: "Intercom",
    square_image:
      "https://merge-api-public.s3.amazonaws.com/media/Intercom_Square_Logo_V9D2LCb.png",
  },
  {
    id: "seed-recruiterflow",
    name: "Recruiterflow",
    square_image:
      "https://merge-api-public.s3.amazonaws.com/media/RecruiterFlow_Square_Logo_0pzjFF2.jpg",
  },
  {
    id: "seed-peoplehr",
    name: "PeopleHR",
    square_image: "https://merge-api-public.s3.amazonaws.com/media/PeopleHR_Access_Square.png",
  },
  {
    id: "seed-oracle-taleo",
    name: "Oracle Taleo",
    square_image: "https://merge-api-public.s3.amazonaws.com/media/Taleo_Square_Logo.jpg",
  },
  {
    id: "seed-zendesk",
    name: "Zendesk",
    square_image: "https://merge-api-public.s3.amazonaws.com/media/PlatformZendesk_9qMuXiF.png",
  },
  {
    id: "seed-azure-devops",
    name: "Azure DevOps",
    square_image: "https://merge-api-public.s3.amazonaws.com/media/Azure_DevOps_Square_Logo.png",
  },
  {
    id: "seed-greenhouse-job-board-api",
    name: "Greenhouse Job Board API",
    square_image: "https://merge-api-public.s3.amazonaws.com/media/Greenhouse_Square_Logo.jpeg",
  },
  {
    id: "seed-tellent-recruitee",
    name: "Tellent Recruitee",
    square_image: "https://merge-api-public.s3.amazonaws.com/media/tellent_recruitee_square.png",
  },
  {
    id: "seed-sesame",
    name: "Sesame",
    square_image: "https://merge-api-public.s3.amazonaws.com/media/PlatformSesame.png",
  },
  {
    id: "seed-paychex",
    name: "Paychex",
    square_image: "https://merge-api-public.s3.amazonaws.com/media/Paychex_Square_Logo.png",
  },
  {
    id: "seed-shortcut",
    name: "Shortcut",
    square_image: "https://merge-api-public.s3.amazonaws.com/media/Shortcut_Square_Logo.jpeg",
  },
  {
    id: "seed-polymer",
    name: "Polymer",
    square_image: "https://merge-api-public.s3.amazonaws.com/media/Polymer_square.png",
  },
  {
    id: "seed-pivotal-tracker",
    name: "Pivotal Tracker",
    square_image: "https://merge-api-public.s3.amazonaws.com/media/PivotalTracker_square.png",
  },
  {
    id: "seed-ashby",
    name: "Ashby",
    square_image: "https://merge-api-public.s3.amazonaws.com/media/Ashby_Square_Logo_3uQWavw.png",
  },
  {
    id: "seed-teamwork",
    name: "Teamwork",
    square_image: "https://merge-api-public.s3.amazonaws.com/media/Teamwork_Square_Logo.png",
  },
  {
    id: "seed-ukg-pro",
    name: "UKG Pro",
    square_image: "https://merge-api-public.s3.amazonaws.com/media/UKG_square.png",
  },
  {
    id: "seed-paylocity",
    name: "Paylocity",
    square_image:
      "https://merge-api-public.s3.amazonaws.com/media/Paylocity_Square_Logo_LGm1Fdn.png",
  },
  {
    id: "seed-talentlyft",
    name: "TalentLyft",
    square_image: "https://merge-api-public.s3.amazonaws.com/media/PlatformTalentLyft.png",
  },
  {
    id: "seed-copper",
    name: "Copper",
    square_image: "https://merge-api-public.s3.amazonaws.com/media/PlatformCopper.jpg",
  },
  {
    id: "seed-square-payroll",
    name: "Square Payroll",
    square_image: "https://merge-api-public.s3.amazonaws.com/media/Square_Square_Logo.jpg",
  },
  {
    id: "seed-clickup",
    name: "ClickUp",
    square_image: "https://merge-api-public.s3.amazonaws.com/media/ClickUp_Square_Logo.png",
  },
  {
    id: "seed-breezy",
    name: "Breezy",
    square_image: "https://merge-api-public.s3.amazonaws.com/media/Breezy_Square_Logo.jpg",
  },
];
